import React from "react";
import classes from "./Recognition.module.scss";
import CustomImage from "../../CustomImage";
import { Container, Row } from "react-bootstrap";

const Recognition: React.FC<{ footerData: any }> = ({ footerData }) => {
  return (
    <Container>
      <div className={classes.lineBottom} />
      <div id="RecogLogo" className={classes.recognitions}>
        <Row className="text-center">
          <h3>{footerData?.recognitionTitle || ""}</h3>
        </Row>
        <div className={classes.RegLogo}>
          {footerData?.recognitiondata?.logoimages?.length > 0 &&
            footerData?.recognitiondata?.logoimages?.map((images: any, index: number) => {
              return <CustomImage src={images?.imageUrl} alt={images?.alt} height={50} width={150} key={index} />;
            })}
        </div>
      </div>
    </Container>
  );
};

export default Recognition;
